import request from '../utils/request';
import Cookies from 'js-cookie';
// --- Bio page (singleton intro content) ---
export function fetchBioPageAdmin() {
    return request()
        .get('/api/v1/admin/bio-page/')
        .send();
}
export function updateBioIntro(introContent) {
    return request()
        .patch('/api/v1/admin/bio-page/')
        .send({ intro_content: introContent });
}
// --- Bio categories ---
export function createBioCategory(payload) {
    return request()
        .post('/api/v1/admin/bio-categories/')
        .send(payload);
}
export function updateBioCategory(id, payload) {
    return request()
        .patch(`/api/v1/admin/bio-categories/${id}/`)
        .send(payload);
}
export function deleteBioCategory(id) {
    return request()
        .delete(`/api/v1/admin/bio-categories/${id}/`)
        .send();
}
export function reorderBioCategories(items) {
    return request()
        .patch('/api/v1/admin/bio-categories/reorder/')
        .send(items);
}
const hasProfileImageFile = (payload) => typeof File !== 'undefined' && payload.profile_image instanceof File;
const buildMemberFormData = (payload) => {
    const formData = new FormData();
    if (payload.bio_category !== undefined)
        formData.append('bio_category', payload.bio_category);
    if (payload.name !== undefined)
        formData.append('name', payload.name);
    if (payload.credentials !== undefined)
        formData.append('credentials', payload.credentials);
    if (payload.title !== undefined)
        formData.append('title', payload.title);
    if (payload.biography !== undefined)
        formData.append('biography', payload.biography);
    if (payload.is_active !== undefined)
        formData.append('is_active', String(payload.is_active));
    if (payload.profile_image)
        formData.append('profile_image', payload.profile_image);
    if (payload.remove_profile_image)
        formData.append('remove_profile_image', 'true');
    return formData;
};
export function createBioMember(payload) {
    if (hasProfileImageFile(payload)) {
        return fetch('/api/v1/admin/bio-members/', {
            method: 'POST',
            credentials: 'include',
            headers: { 'X-CSRFToken': Cookies.get('csrftoken') || '' },
            body: buildMemberFormData(payload),
        });
    }
    return request()
        .post('/api/v1/admin/bio-members/')
        .send(payload);
}
export function updateBioMember(id, payload) {
    if (hasProfileImageFile(payload) || payload.remove_profile_image) {
        return fetch(`/api/v1/admin/bio-members/${id}/`, {
            method: 'PATCH',
            credentials: 'include',
            headers: { 'X-CSRFToken': Cookies.get('csrftoken') || '' },
            body: buildMemberFormData(payload),
        });
    }
    return request()
        .patch(`/api/v1/admin/bio-members/${id}/`)
        .send(payload);
}
export function deleteBioMember(id) {
    return request()
        .delete(`/api/v1/admin/bio-members/${id}/`)
        .send();
}
export function reorderBioMembers(items) {
    return request()
        .patch('/api/v1/admin/bio-members/reorder/')
        .send(items);
}
